import React from 'react'
import { useInfiniteHits, Highlight, useSearchBox  } from 'react-instantsearch'
import { useTheme } from '@emotion/react'
import { Link } from 'gatsby'
import { onSubmit } from './input'
import Button from 'components/button.js'
import useGetAllBuilderProducts from 'hooks/useGetAllBuilderProducts.js'
import paths from 'data/paths.json'

export default function SearchResults() {
    const theme = useTheme()
    const { query } = useSearchBox()
    const { items } = useInfiniteHits()

    const defaultResults = useGetAllBuilderProducts()?.filter(({ legacy }) => !legacy)
    const myitems = items?.length > 0 ? items : defaultResults

    return (
        <div
            className='d-flex col g-5 mx-auto w-100'
            style={{
                maxWidth: 794,
                paddingTop: 8,
            }}
        >
            <h4 className='black'>
                {query ? 'Suggestions' : 'Trending searches'}
            </h4>
            <div className='d-flex col g-3'>
                {myitems.slice(0, 5).map(item => {
                    const { id, url, name } = item
                    return(
                        <p key={id}>
                            <Link
                                to={url}
                                className='black p td-0 t-250'
                                css={{
                                    '&:hover': {
                                        textDecorationColor: 'initial'
                                    },
                                    '& mark': {
                                        backgroundColor: 'transparent',
                                        color: theme.colors.primary
                                    }
                                }}
                            >
                                {
                                    query ?
                                        <Highlight attribute='name' hit={item} /> :
                                        `\`${name}\``
                                }
                            </Link>
                        </p>
                    )
                })}
            </div>
            <div className='d-flex j-center'>
                {query ?
                    <Button
                        onClick={e => onSubmit(e, query, items)}
                        variant='primary'
                    >
                        Search RANE
                    </Button>
                    :
                    <Button
                        to={paths.root.products.path}
                        variant='primary'
                        className='hover-opacity'
                    >
                        BROWSE ALL PRODUCTS
                    </Button>
                }
            </div>
        </div>
    )
}
